module.exports = __webpack_public_path__ + "img/flag-french.5319826c.png";